import { render, staticRenderFns } from "./crmPanel.vue?vue&type=template&id=6a9c740c&"
import script from "./crmPanel.vue?vue&type=script&lang=js&"
export * from "./crmPanel.vue?vue&type=script&lang=js&"
import style0 from "./crmPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports